/*
 * ------------ Theme Common JS ------------
 */

function setAppearanceClass() {
  const sections = document.querySelectorAll(
    "[data-has-appearance-animation='true']"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("init-appearance-animation");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.01 }
  );

  sections.forEach((section) => observer.observe(section));
}

function initSectionSliderLayout(section) {
  if (!section.closest("[data-section-has-card-slider='true']")) return;

  const sliderEl = section.querySelector(".js-section-card-slider");
  if (!sliderEl) return;

  const paginationEl = section.querySelector(".slider-pagination");
  const nextBtn = section.querySelector(".slider-nav-button--next");
  const prevBtn = section.querySelector(".slider-nav-button--prev");
  const hasNavigation = sliderEl.getAttribute("data-navigation") === "true";
  const hasPagination = sliderEl.getAttribute("data-pagination") === "true";

  const sliderLoop = sliderEl.getAttribute("data-loop") === "true";
  const hasSliderAutoplay = sliderEl.getAttribute("data-autoplay") === "true";
  const pauseAutoplayOnHover =
    sliderEl.getAttribute("data-autoplay-pause-on-hover") === "true";
  const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 8000);
  const slidesPerRow = Number(sliderEl.dataset.slidesPerRow || 4);
  const slidesPerRowMobile = Number(sliderEl.dataset.slidesPerRowMobile || 1);

  const slidesPerRow576 = slidesPerRow > 1 ? 2 : 1;
  const slidesPerRow990 =
    slidesPerRow > 2 ? slidesPerRow576 + 1 : slidesPerRow576;
  const slidesPerRow1200 = slidesPerRow >= 4 ? 4 : slidesPerRow;

  const sliderSettings = {
    loop: sliderLoop,
    slidesPerView: slidesPerRowMobile,
    spaceBetween: 12,
    speed: 800,
    watchSlideProgress: true,
    allowTouchMove: true,
    mousewheel: {
      forceToAxis: true,
    },
    a11y: {
      //scrollOnFocus: sliderLoop ? false : true,
      scrollOnFocus: false,
    },
    autoplay: hasSliderAutoplay
      ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: pauseAutoplayOnHover,
        }
      : false,
    pagination: hasPagination
      ? {
          el: paginationEl,
          clickable: true,
        }
      : false,
    navigation: hasNavigation
      ? {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: "swiper-button-disabled",
        }
      : false,
    breakpoints: {
      576: {
        slidesPerView: slidesPerRow576,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: slidesPerRow990,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: slidesPerRow1200,
        spaceBetween: 20,
      },
    },
    on: {
      autoplayTimeLeft(s, time, progress) {
        if (hasPagination && paginationEl) {
          paginationEl.style.setProperty("--slider-progress", 1 - progress);
        }
      },
    },
  };

  new Swiper(sliderEl, sliderSettings);

  const sliderContainer = section.querySelector(".section-card-container");
  sliderContainer?.addEventListener("mouseleave", () => {
    const focusElement = document.activeElement;
    if (sliderContainer.contains(focusElement)) {
      focusElement.blur();
    }
  });

  if (hasSliderAutoplay && sliderEl.swiper) {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sliderEl.swiper.autoplay.resume();
        } else {
          sliderEl.swiper.autoplay.pause();
        }
      });
    });

    sectionObserver.observe(section);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const sectionsWithCardSlider = document.querySelectorAll(
    "[data-section-has-card-slider='true']"
  );
  sectionsWithCardSlider.forEach(initSectionSliderLayout);

  setAppearanceClass();
});

document.addEventListener("shopify:section:load", function (event) {
  if (typeof event.target?.querySelector !== "function") return;

  const section = event.target?.querySelector(
    "[data-section-has-card-slider='true']"
  );
  if (section) initSectionSliderLayout(section);

  setAppearanceClass();
});

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((element) => element.offsetParent !== null);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-mobile-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

function pauseAllMedia(parentElement = document, exceptElement = null) {
  parentElement.querySelectorAll(".js-youtube").forEach((video) => {
    if (exceptElement && exceptElement.contains(video)) return;
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  parentElement.querySelectorAll(".js-vimeo").forEach((video) => {
    if (exceptElement && exceptElement.contains(video)) return;
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  parentElement.querySelectorAll("video").forEach((video) => {
    if (exceptElement && exceptElement.contains(video)) return;
    video.pause();
  });
  parentElement.querySelectorAll("product-model").forEach((model) => {
    if (exceptElement && exceptElement.contains(model)) return;
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  cents = parseInt(cents, 10);

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function slideUp(toggleEl, contentEl, duration = 300) {
  // Get the current height of the element
  const height = contentEl.clientHeight;

  // Set animation styles
  contentEl.style.transitionProperty = "height, margin, padding";
  contentEl.style.transitionDuration = duration + "ms";
  contentEl.style.overflow = "hidden";

  // Set initial values
  contentEl.style.height = height + "px";
  contentEl.style.padding = "0";
  contentEl.style.margin = "0";

  // Delay to start animation
  setTimeout(function () {
    // Set the values ​​for hiding the element
    contentEl.style.height = "0";
    contentEl.style.padding = "0";
    contentEl.style.margin = "0";
  }, 10);

  // Delay for animation to complete
  setTimeout(function () {
    // Remove installed styles after animation
    toggleEl.classList.remove("active");
    contentEl.classList.remove("active");
    contentEl.style.removeProperty("height");
    contentEl.style.removeProperty("padding");
    contentEl.style.removeProperty("margin");
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("transition-duration");
    contentEl.style.removeProperty("transition-property");
  }, duration);
}

function slideDown(toggleEl, contentEl, duration = 300) {
  toggleEl.classList.add("active");
  contentEl.classList.add("active");
  contentEl.style.overflow = "hidden";
  contentEl.style.height = "0";

  const height = contentEl.scrollHeight;

  setTimeout(function () {
    contentEl.style.height = height + "px";
  }, 10);

  setTimeout(function () {
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("height");
  }, duration);
}

(function () {
  function copyURI(e, copyLink) {
    e.preventDefault();

    const url = window.location.href;

    const handleCopy = (btn, success) => {
      if (success) {
        btn.classList.add("copied");
        setTimeout(() => btn.classList.remove("copied"), 1000);
      } else {
        btn.classList.add("notCopied");
        setTimeout(() => btn.classList.remove("notCopied"), 1000);
      }
    };

    // Modern Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => handleCopy(copyLink, true))
        .catch(() => handleCopy(copyLink, false));
    } else {
      // Fallback for unsupported browsers
      const textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed"; // avoid scrolling
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        handleCopy(copyLink, successful);
      } catch (err) {
        handleCopy(copyLink, false);
      }

      document.body.removeChild(textArea);
    }
  }

  const copyLinks = document.querySelectorAll(".copy-btn");
  copyLinks.forEach((copyLink) =>
    copyLink.addEventListener("click", (e) => copyURI(e, copyLink))
  );
})();

if (!Element.prototype.replaceChildren) {
  Element.prototype.replaceChildren = function (...nodes) {
    while (this.firstChild) this.removeChild(this.firstChild);
    this.append(...nodes);
  };
}

// [Theme custom event] - Cart UI refresh event
document.addEventListener("cart:refresh", (event) => {
  const sectionsToUpdate = [
    {
      id: "cart-icon-bubble",
      selector: ".cart-count-bubble",
    },
    {
      id: "cart-drawer",
      selector: "#CartDrawer",
    },
    {
      id: "main-cart",
      selector: ".main-cart",
    },
  ];

  const sectionIds = sectionsToUpdate.map((section) => section.id).join(",");

  fetch(`${routes.cart_url}?sections=${sectionIds}`)
    .then((response) => response.json())
    .then((sections) => {
      sectionsToUpdate.forEach((section) => {
        const sectionHTML = sections[section.id];
        if (!sectionHTML) return;

        const html = new DOMParser().parseFromString(sectionHTML, "text/html");
        const selector = section.selector;

        const sourceElement = html.querySelector(selector);
        const destinationElements = document.querySelectorAll(selector);

        if (sourceElement && destinationElements.length > 0) {
          destinationElements.forEach((destinationElement) => {
            destinationElement.innerHTML = sourceElement.innerHTML;
            if (sourceElement.classList.contains("is-empty")) {
              destinationElement.classList.add("is-empty");
            } else {
              destinationElement.classList.remove("is-empty");
            }
          });
        }
      });
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
    });
});

/*
 * ------------ Shopify Common JS ------------
 */

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    if (!opt) return;
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/*
 * ------------ Theme Web Components ------------
 */

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.input = this.querySelector("input");
    this.isCartItem = Boolean(this.closest(".cart-item"));

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    this.setMinimumDisable();

    var eventList = ["paste", "input"];
    for (const event of eventList) {
      this.input.addEventListener(event, (e) => {
        const value = e.currentTarget.value;
        const numberRegex = this.isCartItem ? /^\d*$/ : /^0*?[1-9]\d*$/;

        if (numberRegex.test(value) || value === "") {
        } else {
          e.currentTarget.value = 1;
        }

        this.setMinimumDisable();
      });
    }

    this.input.addEventListener("focusout", (e) => {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
        this.setMinimumDisable();
      }
    });
  }

  setMinimumDisable() {
    const minusBtn = this.querySelector('button[name="minus"]');
    if (!minusBtn || !this.input) return;

    if (this.input.value == 1) {
      minusBtn.classList.add("disabled");
    } else {
      minusBtn.classList.remove("disabled");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    this.setMinimumDisable();
  }
}

if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetBtn = this.querySelector(".js-search-input-reset");

    this.input?.form?.addEventListener("reset", this.onFormReset.bind(this));
    this.input?.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.resetBtn?.addEventListener("click", this.onFormReset.bind(this));
  }

  connectedCallback() {
    this.toggleResetBtn(this.input?.value);
  }

  toggleResetBtn(value) {
    if (!this.resetBtn) return;

    if (value) {
      this.resetBtn.style.display = "flex";
    } else {
      this.resetBtn.style.display = "none";
    }
  }

  onChange(event) {
    this.toggleResetBtn(event.target.value);
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();

    if (this.input) {
      if (this.closest(".section-search") && window.location.search) {
        const params = new URLSearchParams(window.location.search);
        const q = params.get("q");
        if (this.input.value !== q) {
          setTimeout(() => {
            this.input.value = q;
            this.input.focus();
            this.toggleResetBtn(this.input.value);
          }, 0);
        } else {
          const cleanURL = window.location.pathname;
          window.location.href = cleanURL;
        }
      } else {
        this.input.value = "";
        this.input.focus();
        this.toggleResetBtn("");
      }
    }
  }
}

if (!customElements.get("search-form")) {
  customElements.define("search-form", SearchForm);
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.closeBtn = this.querySelector(".modal-close-button");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );

    this.closeBtn?.addEventListener(
      "click",
      this.onCloseButtonClick.bind(this)
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-drawer`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-drawer`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement?.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

if (!customElements.get("menu-drawer")) {
  customElements.define("menu-drawer", MenuDrawer);
}

class HeaderMobileDrawer extends MenuDrawer {
  constructor() {
    super();
    this.header = document.querySelector(".shopify-section-header");
    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.openBtn = this.querySelector(".js-menu-drawer-open");
    this.closeBtn = this.querySelector(".js-menu-drawer-close");
    this.isOpen = false;

    this.closeBtn?.addEventListener("click", () => {
      this.closeMenuDrawer(this.openBtn);
    });
  }

  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("overflow-hidden-mobile-menu");
    this.isOpen = true;
    this.openScrollY = window.scrollY;

    // styles for forced disable body scroll on iOS
    this.lockScrollBodyOnIos();
  }

  closeMenuDrawer(elementToFocus) {
    if (!elementToFocus) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    document.body.classList.remove("overflow-hidden-mobile-menu");
    document.body.classList.remove("overflow-hidden");
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    // close mega menus mobile if open
    const megaMenuLinks = this.querySelectorAll(
      ".header-sidebar__nav-item--megamenu"
    );
    if (megaMenuLinks && megaMenuLinks.length) {
      megaMenuLinks.forEach((link) => {
        const megaMenuEl = link.querySelector(".mega-menu-mobile");
        if (!megaMenuEl) return;
        megaMenuEl.classList.remove("mega-menu-mobile--visible");
      });
    }

    const megaSubmenuLinks = this.querySelectorAll(
      ".header-sidebar__nav-item--megasubmenu"
    );
    if (megaSubmenuLinks && megaSubmenuLinks.length) {
      megaSubmenuLinks.forEach((link) => {
        const megaSubmenuEl = link.querySelector(".mega-submenu-mobile");
        if (!megaSubmenuEl) return;
        megaSubmenuEl.classList.remove("mega-submenu-mobile--visible");
      });
    }

    // close search modal if open
    const searchModal = document.querySelector(".header-search-modal");
    if (searchModal && searchModal.getAttribute("open")) {
      const headerSearch = document.querySelector("header-search");
      if (headerSearch && typeof headerSearch.close === "function") {
        headerSearch.close(null, elementToFocus);
      }
    }

    // styles for forced disable body scroll on iOS
    this.unlockScrollBodyOnIos();

    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.isOpen = false;
  }

  lockScrollBodyOnIos() {
    if (navigator.userAgent.indexOf("iPhone") > -1) {
      if (this.iosTimeoutId) clearTimeout(this.iosTimeoutId);
      document.documentElement.style.setProperty(
        "--current-body-scroll",
        `${-1 * this.openScrollY}px`
      );
      document.documentElement.style.setProperty("scroll-behavior", "unset");

      this.iosTimeoutId = setTimeout(function () {
        document.body.classList.add("forced-scroll-locked");
      }, 400);
    }
  }

  unlockScrollBodyOnIos() {
    if (navigator.userAgent.indexOf("iPhone") > -1) {
      document.body.classList.remove("forced-scroll-locked");
      document.documentElement.scrollTop = this.openScrollY;
      document.documentElement.style.removeProperty("--current-body-scroll");
      document.documentElement.style.removeProperty("scroll-behavior");
    }
  }
}

if (!customElements.get("header-mobile-drawer")) {
  customElements.define("header-mobile-drawer", HeaderMobileDrawer);
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(
      '[id^="ModalCloseBtn-"], [id^="ModalCloseOverlay-"]'
    ).forEach((el) => el.addEventListener("click", () => this.hide(false)));

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        ) {
          this.hide();
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.addEventListener(
      "transitionend",
      () => {
        trapFocus(this, this.querySelector('[role="dialog"]'));
      },
      { once: true }
    );
  }

  hide() {
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    document.body.classList.remove("overflow-hidden");
  }
}

if (!customElements.get("modal-dialog")) {
  customElements.define("modal-dialog", ModalDialog);
}

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }
}

if (!customElements.get("product-modal")) {
  customElements.define("product-modal", ProductModal);
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

if (!customElements.get("modal-opener")) {
  customElements.define("modal-opener", ModalOpener);
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener("click", this.loadContent.bind(this));
    }

    if (this.dataset.autoplay === "true") {
      this.loadContent();
    }
  }

  loadContent() {
    const parentEl =
      this.closest(".product__media") || this.closest(".product-media-modal");
    pauseAllMedia(parentEl);

    if (this.getAttribute("loaded")) return;

    const template = this.querySelector("template");
    if (!template) return;

    const content = document.createElement("div");
    content.appendChild(template.content.firstElementChild.cloneNode(true));
    this.setAttribute("loaded", true);

    const media = content.querySelector("video, model-viewer, iframe");
    if (!media) return;

    const deferredElement = this.appendChild(media);

    if (["VIDEO", "IFRAME"].includes(deferredElement.nodeName)) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            let shouldAutoplay = false;
            const parentSlide = entry.target.closest(".swiper-slide");
            if (parentSlide) {
              if (parentSlide.classList.contains("swiper-slide-active")) {
                shouldAutoplay = true;
              }
            } else {
              if (entry.intersectionRatio > 0.7) {
                shouldAutoplay = true;
              }
            }

            if (shouldAutoplay) {
              if (
                (this.dataset.autoplay === "true" &&
                  !this.closest("product-modal")) ||
                (this.dataset.autoplay === "true" &&
                  this.closest("product-modal")?.hasAttribute("open"))
              ) {
                pauseAllMedia(parentEl, this);

                if (entry.target.nodeName === "VIDEO") {
                  entry.target.play()?.catch((error) => {
                    console.error("Error playing video:", error);
                  });
                } else if (
                  entry.target.nodeName === "IFRAME" &&
                  entry.target.contentWindow
                ) {
                  if (entry.target.classList.contains("js-youtube")) {
                    entry.target.contentWindow.postMessage(
                      '{"event":"command","func":"playVideo","args":""}',
                      "*"
                    );
                  } else {
                    entry.target.contentWindow.postMessage(
                      '{"method":"play"}',
                      "*"
                    );
                  }
                }
              }
            } else {
              if (entry.target.nodeName === "VIDEO") {
                entry.target.pause();
              } else if (
                entry.target.nodeName === "IFRAME" &&
                entry.target.contentWindow
              ) {
                if (entry.target.classList.contains("js-youtube")) {
                  entry.target.contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    "*"
                  );
                } else {
                  entry.target.contentWindow.postMessage(
                    '{"method":"pause"}',
                    "*"
                  );
                }
              }
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      videoObserver.observe(deferredElement);
    }

    const modelViewer = this.closest(".swiper-slide-active")?.querySelector(
      "model-viewer"
    );
    if (
      modelViewer &&
      !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")
    ) {
      const swiper = this.closest(".swiper")?.swiper;
      if (swiper) {
        swiper.params.noSwiping = true;
        swiper.params.noSwipingClass = "swiper-slide";
      }
    }

    this.querySelectorAll(
      "video, .shopify-model-viewer-ui__controls-overlay"
    ).forEach((media) => {
      if (this.getAttribute("loaded") === "true") {
        media.addEventListener("click", (event) => {
          pauseAllMedia(parentEl, this);
        });
      }
    });
  }
}

if (!customElements.get("deferred-media")) {
  customElements.define("deferred-media", DeferredMedia);
}

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );

    const $this = this;
    const target = $this.querySelector("model-viewer");

    const observer = new MutationObserver((records) => {
      if ($this.closest(".swiper") && $this.closest(".swiper").swiper) {
        const swiperObj = $this.closest(".swiper").swiper;
        if (!target.classList.contains("shopify-model-viewer-ui__disabled")) {
          swiperObj.params.noSwiping = true;
          swiperObj.params.noSwipingClass = "swiper-slide";
        } else {
          swiperObj.params.noSwiping = false;
        }
      }
    });

    observer.observe(target, { attributes: true });
  }
}

if (!customElements.get("product-model")) {
  customElements.define("product-model", ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener("DOMContentLoaded", () => {
  window.ProductModel?.loadShopifyXR();
});

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.currentCombinedProductURL = null;
    this.variantMediaDisplay =
      this.closest(".product")?.querySelector(".product__media")?.dataset
        ?.variantMediaDisplay || "show_all";
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    const combinedProductURL = event.target.dataset?.productUrl;

    this.updateOptions();
    // updateMasterId method updates currentVariant from liquid <script data-all-variations-no-high>
    this.updateMasterId();
    this.toggleAddButton(true, "");

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    // -----
    // checking for high-variant and combined products
    // if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL && combinedProductURL !== this.dataset.url) {
          this.isCombinedListingsNeedUpdate = true;
          this.currentCombinedProductURL = combinedProductURL;
        }
      }
    }
    // -----

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (
        this.currentVariant?.featured_media &&
        this.variantMediaDisplay === "show_all"
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        this.updateMedia(mediaId);
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
        combinedProductURL: combinedProductURL,
      });
      this.renderProductInfo(requestUrl);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia(mediaId) {
    if (!mediaId) return;

    const mediaEl = document.querySelector(
      `[data-section="product-media-${this.dataset.section}"]`
    );
    if (!mediaEl) return;

    // for slider and slider_previews layout
    const sliderEl = mediaEl.querySelector(".js-media-list");
    if (sliderEl && sliderEl.swiper) {
      sliderEl.querySelectorAll(".swiper-slide").forEach((slide, index) => {
        const slideMediaId = slide.dataset?.mediaId;
        if (slideMediaId === mediaId) {
          const findIndex = sliderEl.swiper.slides.findIndex((slideEl) => {
            return slideEl.dataset?.mediaId === slideMediaId;
          });
          const fallbackIndex = Number(
            slide.dataset?.swiperSlideIndex || index
          );
          const swiperSlideIndex = findIndex !== -1 ? findIndex : fallbackIndex;
          sliderEl.swiper.slideTo(swiperSlideIndex, 800);
        }
      });
    }

    // for stacked and grid layout
    const stackedOrGridEl =
      mediaEl.querySelector(
        ".product__media-list[data-desktop-type='stacked']"
      ) ||
      mediaEl.querySelector(".product__media-list[data-desktop-type='grid']") ||
      mediaEl.querySelector(".product__media-list[data-mobile-type='grid']");
    if (stackedOrGridEl) {
      stackedOrGridEl
        .querySelectorAll("[data-media-id]")
        .forEach((mediaItem) => {
          const mediaItemId = mediaItem.dataset?.mediaId;
          if (mediaItemId === mediaId) {
            mediaItem.classList.add("stacked-or-grid-active");
          } else {
            mediaItem.classList.remove("stacked-or-grid-active");
          }
        });
    }
  }

  updateURL() {
    if (this.dataset.updateUrl === "false") return;
    const baseUrl = this.currentCombinedProductURL || this.dataset.url;
    const newUrl = this.currentVariant
      ? `${baseUrl}?variant=${this.currentVariant.id}`
      : baseUrl;

    window.history.replaceState({}, "", newUrl);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.disabled = false;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });

    // [Start theme custom event] - Variant change event
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: {
          variant: this.currentVariant,
          previousVariant: this.previousVariant || null,
          formElement: this,
          sectionId: this.dataset.section,
        },
      })
    );

    this.previousVariant = this.currentVariant;
    // [End theme custom event] - Variant change event
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.options[0]
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant.options[index - 1] === previousOptionSelected
        )
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];

    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;

      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];

      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }

  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    const selectedValues = controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    });

    return selectedValues;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelectorAll("pickup-availability");
    if (!pickUpAvailability) return;
    pickUpAvailability.forEach((el) => {
      if (this.currentVariant && this.currentVariant.available) {
        el.fetchAvailability(this.currentVariant.id);
      } else {
        el.removeAttribute("available");
        el.innerHTML = "";
      }
    });
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.isCombinedListingsNeedUpdate) {
              // Clear stale variant data so getVariantData() re-reads from the
              // updated picker DOM (now populated with the new product's variants).
              this.variantData = null;
              // Promote the combined product URL so subsequent variant changes
              // within this product resolve correctly via the normal path.
              this.dataset.url = this.currentCombinedProductURL;

              // Sync the high-variant flag from the new product's picker so
              // subsequent option changes on the switched product don't
              // incorrectly re-enter the high-variant fetch path.
              const newPickerSource = html.getElementById(
                `variant-picker-${
                  this.dataset.originalSection || this.dataset.section
                }`
              );
              if (newPickerSource) {
                const newHighVariant =
                  newPickerSource.dataset.isHighVariantProduct || "false";
                this.dataset.isHighVariantProduct = newHighVariant;
              }

              // Refresh the cached variantMediaDisplay from the updated media
              // container so media updates on subsequent variant changes remain correct.
              const newMediaEl = document.querySelector(
                `[data-section="product-media-${this.dataset.section}"]`
              );
              if (newMediaEl) {
                this.variantMediaDisplay =
                  newMediaEl.dataset.variantMediaDisplay || "show_all";
              }
            }
            if (this.currentVariant) {
              this.updateVariantInput();
              if (
                this.currentVariant.featured_media &&
                this.variantMediaDisplay === "show_all"
              ) {
                // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
                const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
                this.updateMedia(mediaId);
              }
            }
          } catch (err) {}
        }
        // -----

        this.updateElementsAfterFetch(html);

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  toggleAddButton(disable = true, text) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const addButtonText = addButton.querySelector(".js-change-button-text");

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        if (text && addButtonText) {
          addButtonText.textContent = text;

          if (text === window.variantStrings.unavailable) {
            addButton.dataset.status = "unavailable";
          } else {
            addButton.dataset.status = "sold-out";
          }
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
        addButton.dataset.status = "available";
      }
    });
  }

  resetErrorMessage() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const parentEl =
        productForm.closest(".product-sticky-add-bar") ||
        productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  setUnavailable() {
    const price = document.querySelectorAll(
      `[data-id="Price-${this.dataset.section}"]`
    );
    const priceSticky = document.querySelectorAll(
      `[data-id="Price-sticky-${this.dataset.section}"]`
    );
    const inventory = document.querySelectorAll(
      `[data-id="Inventory-${this.dataset.section}"]`
    );
    const sku = document.querySelectorAll(
      `[data-id="Sku-${this.dataset.section}"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[data-id^="ColorName-${this.dataset.section}"]`
    );

    this.toggleAddButton(true, window.variantStrings.unavailable);
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) input.disabled = true;
    });
    price.forEach((el) => el.classList.add("visibility-hidden"));
    priceSticky.forEach((el) => el.classList.add("visibility-hidden"));
    inventory.forEach((el) => el.classList.add("visibility-hidden"));
    sku.forEach((el) => el.classList.add("visibility-hidden"));
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-all-variants-no-high]").textContent);
    return this.variantData;
  }

  updateElementsAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    // price
    const priceDestination = document.querySelectorAll(
      `[data-id="Price-${currentSectionId}"]`
    );
    const priceSource = html.querySelector(
      `[data-id="Price-${sourceSectionId}"]`
    );
    if (priceSource) {
      priceDestination.forEach((el) => {
        el.innerHTML = priceSource.innerHTML;
        el.classList.remove("visibility-hidden");
      });
    }

    const priceStickyDestination = document.querySelectorAll(
      `[data-id="Price-sticky-${currentSectionId}"]`
    );
    const priceStickySource = html.querySelector(
      `[data-id="Price-sticky-${sourceSectionId}"]`
    );
    if (priceStickySource) {
      priceStickyDestination.forEach((el) => {
        el.innerHTML = priceStickySource.innerHTML;
        el.classList.remove("visibility-hidden");
      });
    }

    // inventory
    const inventorySource = html.querySelector(
      `[data-id="Inventory-${sourceSectionId}"]`
    );
    const inventoryDestination = document.querySelectorAll(
      `[data-id="Inventory-${currentSectionId}"]`
    );
    if (inventorySource) {
      inventoryDestination.forEach((el) => {
        el.innerHTML = inventorySource.innerHTML;
        el.classList.toggle(
          "visibility-hidden",
          inventorySource.innerText === ""
        );
      });
    }

    // sku
    const skuSource = html.querySelector(`[data-id="Sku-${sourceSectionId}"]`);
    const skuDestination = document.querySelectorAll(
      `[data-id="Sku-${currentSectionId}"]`
    );
    if (skuSource) {
      skuDestination.forEach((el) => {
        el.innerHTML = skuSource.innerHTML;
        el.classList.toggle(
          "visibility-hidden",
          skuSource.classList.contains("visibility-hidden")
        );
      });
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[data-id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[data-id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const variantSwatchesSource = html.querySelector(
        `#variant-picker-${sourceSectionId} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = document.querySelector(
        `#variant-picker-${currentSectionId} [data-is-variant-image-swatch="true"]`
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        const quickViewModal = this.closest("quick-view-modal");
        if (quickViewModal) {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML.replaceAll(
              sourceSectionId,
              `quickview-${sourceSectionId}`
            );
        } else {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML;
        }
      }
    }

    // product media
    if (
      this.variantMediaDisplay !== "show_all" ||
      this.isCombinedListingsNeedUpdate
    ) {
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = document.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );
      if (mediaSource && mediaDestination) {
        mediaDestination.innerHTML = mediaSource.innerHTML;

        const parentQuickView = this.closest("quick-view-modal");
        if (parentQuickView) {
          if (typeof parentQuickView.removeDOMElements === "function") {
            parentQuickView.removeDOMElements(mediaDestination);
          }
          if (typeof parentQuickView.initSlider === "function") {
            parentQuickView.initSlider();
          }
        } else {
          // Update zoom modal slides before re-initialising so initZoomSlider
          // picks up the new product's media on its next run.
          // Only the .swiper-wrapper content is replaced so that the close
          // button element (and its ModalDialog constructor listener) is
          // preserved — replacing the full innerHTML would destroy it.
          if (this.isCombinedListingsNeedUpdate) {
            const zoomSource = html.querySelector(
              `#ProductModal-${sourceSectionId}`
            );
            const zoomDest = document.querySelector(
              `#ProductModal-${currentSectionId}`
            );
            if (zoomSource && zoomDest) {
              const zoomSwiperSource =
                zoomSource.querySelector(".swiper-wrapper");
              const zoomSwiperDest = zoomDest.querySelector(".swiper-wrapper");
              if (zoomSwiperSource && zoomSwiperDest) {
                zoomSwiperDest.innerHTML = zoomSwiperSource.innerHTML;
              }
            }
          }

          const section = document.getElementById(
            `shopify-section-${currentSectionId}`
          );

          if (section && typeof window.initProductMediaGallery === "function") {
            window.initProductMediaGallery(section);
          }
        }
      }
    }

    // Combined Listings product-switch-specific updates
    // (only run when the visible product itself has changed, not on variant
    // changes within the same combined product)
    if (this.isCombinedListingsNeedUpdate) {
      const isInQuickView = !!this.closest("quick-view-modal");

      // Product title — update in both the main page and Quick View modal.
      const titleSource = html.querySelector(
        `[data-id="ProductTitle-${sourceSectionId}"]`
      );
      if (titleSource) {
        document
          .querySelectorAll(`[data-id="ProductTitle-${currentSectionId}"]`)
          .forEach((el) => {
            el.innerHTML = titleSource.innerHTML;
          });
        // Only update the browser tab title outside of Quick View.
        if (!isInQuickView) {
          const newTitle = titleSource.textContent.trim();
          if (newTitle) {
            document.title = document.title.replace(
              /^[^|–\-—]+/,
              newTitle + " "
            );
          }
        }
      }

      // Description blocks — identified by their stable ExtendedBlock-{blockId}
      // ids, which are the same in both the current DOM and the fetched HTML.
      // Skip inside Quick View because the block IDs exist in the main page DOM
      // and would incorrectly overwrite the main product content.
      if (!isInQuickView) {
        // Collect IDs that exist in the fetched HTML and update their content.
        const fetchedExtendedBlockIds = new Set();
        html.querySelectorAll("[id^='ExtendedBlock-']").forEach((sourceEl) => {
          fetchedExtendedBlockIds.add(sourceEl.id);
          const destEl = document.getElementById(sourceEl.id);
          if (destEl) {
            destEl.innerHTML = sourceEl.innerHTML;
            destEl.hidden = sourceEl.hidden;
          }
        });

        // Clear any blocks in the current DOM that the new product did not
        // render (e.g. a product with no description omits the block entirely).
        const productSection = document.getElementById(
          `shopify-section-${currentSectionId}`
        );
        if (productSection) {
          productSection
            .querySelectorAll("[id^='ExtendedBlock-']")
            .forEach((destEl) => {
              if (!fetchedExtendedBlockIds.has(destEl.id)) {
                destEl.innerHTML = "";
                destEl.hidden = true;
              }
            });
        }
      }

      // Gift card recipient form wrapper — replaces the inner content so the
      // form appears for gift-card products and disappears for all others.
      if (!isInQuickView) {
        const recipientSource = html.querySelector(
          `[data-id="RecipientFormWrapper-${sourceSectionId}"]`
        );
        const recipientDest = document.querySelector(
          `[data-id="RecipientFormWrapper-${currentSectionId}"]`
        );
        if (recipientSource && recipientDest) {
          recipientDest.innerHTML = recipientSource.innerHTML;
          // Re-execute any <script> tags (e.g. recipient-form.js) that were
          // injected via innerHTML and therefore not executed by the browser.
          recipientDest.querySelectorAll("script").forEach((oldScript) => {
            const newScript = document.createElement("script");
            Array.from(oldScript.attributes).forEach((attr) =>
              newScript.setAttribute(attr.name, attr.value)
            );
            newScript.textContent = oldScript.textContent;
            oldScript.replaceWith(newScript);
          });
        }
      }
    }
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestionation = document.getElementById(
      `variant-picker-${this.dataset.section}`
    );
    if (!variantPickerSource) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestionation.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-picker-${currentSectionId}`
    );

    if (variantPickerSource && variantPickerDestination) {
      const quickViewModal = this.closest("quick-view-modal");
      if (quickViewModal) {
        variantPickerDestination.innerHTML =
          variantPickerSource.innerHTML.replaceAll(
            sourceSectionId,
            `quickview-${sourceSectionId}`
          );
      } else {
        variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
      }
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
        input.disabled = false;
      } else {
        input.classList.add("disabled");
        //input.disabled = true;
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}

class VariantDropdownSelect extends HTMLElement {
  constructor() {
    super();

    this.currentEl = this.querySelector(".dropdown-select__current");
    this.optionsWrapperEl = this.querySelector(".dropdown-select__options");
    this.hiddenInput = this.querySelector("input[type='hidden']");
    if (!this.currentEl || !this.optionsWrapperEl || !this.hiddenInput) return;

    this.optionsEls = Array.from(this.optionsWrapperEl.querySelectorAll("li"));
    this.inputs = Array.from(this.optionsWrapperEl.querySelectorAll("input"));
    this.hasColorSwatch = this.currentEl?.classList?.contains(
      "dropdown-select__current--with-color"
    );
    this.isActive = false;

    this.optionPosition = this.getOptionPosition();
    this._onCurrentClick = this.onCurrentClick.bind(this);
    this._onKeyUp = this.onKeyUp.bind(this);
    this._onOptionsClick = this.onClickOption.bind(this);
    this._onKeyUpOptions = this.onKeyUpOptions.bind(this);
    this._onOutsideClick = this.onOutsideClick.bind(this);
  }

  connectedCallback() {
    this.currentEl.addEventListener("click", this._onCurrentClick);
    this.currentEl.addEventListener("keyup", this._onKeyUp);
    this.currentEl.addEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.addEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.addEventListener("keyup", this._onKeyUpOptions);
    document.addEventListener("click", this._onOutsideClick);
  }

  disconnectedCallback() {
    this.currentEl.removeEventListener("click", this._onCurrentClick);
    this.currentEl.removeEventListener("keyup", this._onKeyUp);
    this.currentEl.removeEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.removeEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.removeEventListener("keyup", this._onKeyUpOptions);
    document.removeEventListener("click", this._onOutsideClick);
  }

  onCurrentClick(event) {
    event.stopPropagation();
    if (this.isActive) {
      this.onClose();
    } else {
      this.onOpen();
    }
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() === "ENTER") {
      event.preventDefault();
      event.stopPropagation();
      if (this.isActive) {
        this.onClose();
      } else {
        this.onOpen();
      }
    }
  }

  preventDoubleClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onClickOption(event) {
    const optionEl = event.target.closest("li");
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (
      !optionEl ||
      !currentValueEl ||
      !this.optionsWrapperEl.contains(optionEl)
    ) {
      event.preventDefault();
      return;
    }

    const newValue = optionEl.dataset.value;

    const correspondingInput = this.inputs.find((input) => input.value === newValue);
    if (correspondingInput && correspondingInput.classList.contains("disabled")) return;

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    if (this.hasColorSwatch) {
      const newColor = optionEl.dataset.color;
      this.hiddenInput.dataset.colorSwatch = newColor;
      this.currentEl.style.setProperty("--swatch-color", newColor);
    }

    this.hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));

    this.inputs.forEach((el) => el.removeAttribute("checked"));
    if (event.target.tagName === "INPUT") {
      event.target.setAttribute("checked", "true");
    }

    this.onClose();
    this.currentEl.focus();
  }

  onKeyUpOptions(event) {
    if (event.code === "Escape" && this.isActive) {
      event.preventDefault();
      this.onClose();
      this.currentEl.focus();
    }
  }

  onOpen() {
    document.querySelectorAll("variant-dropdown-select").forEach((dropdown) => {
      if (dropdown !== this && typeof dropdown.onClose === "function") {
        dropdown.onClose();
      }
    });

    this.optionsWrapperEl.classList.add("active");
    this.currentEl.setAttribute("aria-expanded", "true");
    this.isActive = true;

    const currentIndex = this.inputs.findIndex((inp) =>
      inp.hasAttribute("checked")
    );
    this.inputs[currentIndex >= 0 ? currentIndex : 0]?.focus();
  }

  onClose() {
    this.optionsWrapperEl.classList.remove("active");
    this.currentEl.setAttribute("aria-expanded", "false");
    this.isActive = false;
  }

  onOutsideClick(event) {
    if (!this.isActive || this.contains(event.target)) return;
    this.onClose();
  }

  getOptionPosition() {
    const parentFieldset = this.closest(".product-form__controls");
    return Number(parentFieldset?.dataset?.optionPosition || -1);
  }

  updateCurrentOption(selectedValues = []) {
    // Method is used to synchronize after changes options in sticky bar.
    if (this.optionPosition === -1) return;
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (!currentValueEl || !selectedValues || !selectedValues.length) return;

    const newValue = selectedValues[this.optionPosition - 1];

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    this.optionsEls.forEach((optionEl) => {
      const liDataValue = optionEl.dataset.value;
      if (newValue === liDataValue && this.hasColorSwatch) {
        const newColor = optionEl.dataset.color;
        this.hiddenInput.dataset.colorSwatch = newColor;
        this.currentEl.style.setProperty("--swatch-color", newColor);
      }
    });
  }
}

if (!customElements.get("variant-dropdown-select")) {
  customElements.define("variant-dropdown-select", VariantDropdownSelect);
}

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    if (this.querySelector("form")) {
      this.form = this.querySelector("form");
      this.form.querySelector("[name=id]").disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    } else {
      if (this.querySelector("[name=id]")) {
        this.querySelector("[name=id]").disabled = false;
      }
      this.querySelector("button[type=submit]")?.addEventListener(
        "click",
        this.onSubmitHandler.bind(this)
      );
    }

    this.cartUIElement =
      this.closest("cart-drawer") ||
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    if (this.cartUIElement) {
      this.submitButton.setAttribute("aria-haspopup", "dialog");
    }

    this.hideErrors = this.dataset.hideErrors === "true";
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;
    const variantInput = (this.form || this).querySelector('input[name="id"]');
    if (!variantInput || variantInput.disabled || !variantInput.value) return;

    this.handleErrorMessage();

    this.submitButton.classList.add("loading");
    const btnSpinner =
      this.submitButton.querySelector(".button-loader") ||
      this.submitButton.querySelector(".loading-overlay__spinner");
    if (btnSpinner) btnSpinner.classList.remove("hidden");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    if (!this.form) {
      formData.append("id", this.querySelector("[name=id]").value);
    }

    if (this.cartUIElement) {
      formData.append(
        "sections",
        this.cartUIElement
          .getSectionsToRender()
          .map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        // If there is a status in the response, then this is an error
        // https://shopify.dev/docs/api/ajax/reference/cart#error-responses
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.description,
            message: response.message,
          });

          // [Start theme custom event] - Cart error event
          document.dispatchEvent(
            new CustomEvent("cart:error", {
              detail: {
                errors: response.description,
                message: response.message,
              },
            })
          );
          const refreshCartUIEvent = new CustomEvent("cart:refresh");
          document.dispatchEvent(refreshCartUIEvent);
          // [End theme custom event] - Cart error event

          this.handleErrorMessage(response.description);
          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cartUIElement) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
          });
        }
        this.error = false;

        // [Start theme custom event] - Variant addition event
        document.dispatchEvent(
          new CustomEvent("variant:add", {
            detail: {
              variant: {
                id: response.variant_id || formData.get("id"),
                quantity:
                  response.quantity || Number(formData.get("quantity") || 1),
                product_title: response.product_title || "",
                variant_title: response.variant_title || "",
                image: response.image || null,
              },
              formElement: this.form,
            },
          })
        );
        // [End theme custom event] - Variant addition event

        // [Start theme custom event] - Cart change event
        fetch(`${routes.cart_url}.js`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            document.dispatchEvent(
              new CustomEvent("cart:change", {
                detail: {
                  cart: parsedState,
                },
              })
            );
          })
          .catch((error) => {
            console.error("Error fetching cart state:", error);
          });
        // [End theme custom event] - Cart change event

        let activeElement = document.activeElement;

        // add to cart from quick-view modal
        const quickAddModal = this.closest("quick-view-modal");
        if (quickAddModal && typeof quickAddModal?.hide === "function") {
          activeElement = quickAddModal.openedBy;
          document.body.addEventListener(
            "quick-view-closed",
            () => {
              setTimeout(() => {
                this.cartUIElement.setActiveElement(activeElement);
                this.cartUIElement.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
          return;
        }

        this.cartUIElement.setActiveElement(activeElement);
        this.cartUIElement.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cartUIElement?.closest("cart-notification")) {
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && cartDrawer.classList.contains("is-empty")) {
            cartDrawer.classList.remove("is-empty");
          }
        }

        if (
          this.cartUIElement?.closest("cart-drawer") &&
          this.cartUIElement?.classList.contains("is-empty")
        ) {
          this.cartUIElement.classList.remove("is-empty");
        }
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.submitButton.classList.remove("loading");
        if (btnSpinner) btnSpinner.classList.add("hidden");
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    const stickyBarParent = this.closest(".product-sticky-add-bar");
    const horizontalProductParent = this.closest(".product-card-horizontal");
    const errorWrapperSelector = ".product-form__error-message-wrapper";

    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(errorWrapperSelector) ||
      stickyBarParent?.querySelector(errorWrapperSelector) ||
      horizontalProductParent?.querySelector(errorWrapperSelector);
    if (!this.errorMessageWrapper) return;

    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message");
    if (!this.errorMessage) return;

    if (this.errorTimeoutId) {
      clearTimeout(this.errorTimeoutId);
      this.errorTimeoutId = null;
    }

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;

      // Auto-hide error message after 3 seconds for product-card-horizontal
      if (horizontalProductParent) {
        this.errorTimeoutId = setTimeout(() => {
          this.errorMessageWrapper.toggleAttribute("hidden", true);
          this.errorMessage.textContent = "";
          this.errorTimeoutId = null;
        }, 3000);
      }
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll(".field--pass");

    passwordField.forEach((el) => {
      const input = el.querySelector("input");
      const btnWrapper = el.querySelector(".button-pass-visibility");
      const btnOpen = el.querySelector(".icon-eye-close");
      const btnClose = el.querySelector(".icon-eye");

      input.addEventListener("input", () => {
        input.value !== ""
          ? (btnWrapper.style.display = "block")
          : (btnWrapper.style.display = "none");
      });

      btnOpen.addEventListener("click", () => {
        input.type = "text";
        btnOpen.style.display = "none";
        btnClose.style.display = "block";
      });

      btnClose.addEventListener("click", () => {
        input.type = "password";
        btnOpen.style.display = "block";
        btnClose.style.display = "none";
      });
    });
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsSlider = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this.initProductRecommendations();
  }

  initProductRecommendations() {
    this.enableLoading();

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          //this.innerHTML = recommendations.innerHTML;
          this.replaceChildren(...recommendations.children);
        }

        if (recommendations.hasAttribute("data-section-has-card-slider")) {
          this.setAttribute("data-section-has-card-slider", "true");
          initSectionSliderLayout(this);
        } else if (recommendations.hasAttribute("data-is-complementary")) {
          this.initComplementarySlider();
        }

        if (recommendations.hasAttribute("data-products-count")) {
          this.setAttribute(
            "data-products-count",
            recommendations.getAttribute("data-products-count")
          );
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.disableLoading();
        this._initialized = true;
      });
  }

  initComplementarySlider() {
    const sliderEl = this.querySelector(".js-complementary-slider");
    if (!sliderEl) return;

    const prevBtn = this.querySelector(".slider-nav-button--prev");
    const nextBtn = this.querySelector(".slider-nav-button--next");
    const paginationEl = this.querySelector(".slider-pagination");

    const sliderSettings = {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 8,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    };

    new Swiper(sliderEl, sliderSettings);
  }

  enableLoading() {
    const loadingEl = this.querySelector(".product-recommendations-loading");
    if (loadingEl) loadingEl.style.display = "flex";
  }

  disableLoading() {
    const loadingEl = this.querySelector(".product-recommendations-loading");
    if (loadingEl) loadingEl.remove();
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }

  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.enableMockTimer =
      this.getAttribute("data-enable-mock-timer") === "true";

    if (this.enableMockTimer) {
      // get data for infinite mock timer
      const INFINITE_DAYS = Number(this.getAttribute("data-mock-end-day") || 2);
      const DIFF_HOURS = Number(this.getAttribute("data-mock-end-hour") || 3);
      const now = new Date();
      const futureDate = new Date(
        now.getTime() + (INFINITE_DAYS * 24 + DIFF_HOURS) * 60 * 60 * 1000
      );
      const year = futureDate.getFullYear();
      const month = String(futureDate.getMonth() + 1).padStart(2, "0");
      const day = String(futureDate.getDate()).padStart(2, "0");
      const hours = String(futureDate.getHours()).padStart(2, "0");
      const minutes = String(futureDate.getMinutes()).padStart(2, "0");
      this.endDate = `${year}-${month}-${day}`;
      this.endTime = `${hours}:${minutes}`;
    } else {
      // get data from section settings
      this.endDate = this.getAttribute("data-end-date");
      this.endTime = this.getAttribute("data-end-time");
    }
    // ----------------------------------------------------------------
    this.interval;
    this.isStarted = false;
    this.setInterval(this.endDate, this.endTime);
  }

  onInit(endDate, endTime) {
    this.completeBehavior = this.getAttribute("data-complete-behavior");
    this.parentEl = this.closest(".block-countdown-timer");
    this.countdownTimerEl = this.querySelector(".countdown-timer__timer");
    this.countdownEndEl = this.querySelector(".countdown-timer__end");
    this.daysEl = this.querySelector(".js-countdown-timer-days");
    this.hoursEl = this.querySelector(".js-countdown-timer-hours");
    this.minutesEl = this.querySelector(".js-countdown-timer-minutes");
    this.secondsEl = this.querySelector(".js-countdown-timer-seconds");
    // ----------------------------------------------------------------
    const countdownDate = new Date(`${endDate}T${endTime}`);
    const now = new Date();
    const distance = countdownDate.getTime() - now.getTime();
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // ----------------------------------------------------------------
    if (distance < 0 && this.completeBehavior === "hide_block") {
      if (this.parentEl) {
        this.parentEl.style.display = "none";
      }
      this.style.display = "none";
      clearInterval(this.interval);
    } else if (distance < 0 && this.completeBehavior === "show_message") {
      if (this.countdownTimerEl) {
        this.countdownTimerEl.style.display = "none";
      }
      if (this.countdownEndEl) {
        this.countdownEndEl.style.display = "flex";
      }
      clearInterval(this.interval);
    } else {
      if (this.daysEl) {
        this.daysEl.textContent = this.getTwoDigitTime(days);
      }

      if (this.hoursEl) {
        this.hoursEl.textContent = this.getTwoDigitTime(hours);
      }

      if (this.minutesEl) {
        this.minutesEl.textContent = this.getTwoDigitTime(minutes);
      }

      if (this.secondsEl) {
        this.secondsEl.textContent = this.getTwoDigitTime(seconds);
      }
    }
  }

  getTwoDigitTime(time) {
    if (String(time).length === 1) {
      return "0" + time;
    }
    if (String(time) === "-1") {
      return "00";
    }
    return time;
  }

  setInterval(endDate, endTime) {
    clearInterval(this.interval);
    this.interval = setInterval(this.onInit.bind(this, endDate, endTime), 1000);
  }
}

if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}
